<template>
  <!-- <v-layout align-center justify-center row wrap color="#f8f8f8" display: flex> -->
  <v-layout>
    <v-flex class="margin">
      <v-card class="v-text-field-title" id="e3">
        <v-toolbar color="#216AA9" dark>
          <v-toolbar-title>การจัดการร้านค้า</v-toolbar-title>
        </v-toolbar>

        <!-- Mobile View -->
        <v-container fluid grid-list-lg v-if="mobileView">
          <!-- ข้อความ -->
          <v-layout>
            <v-flex md9>
              <span class="texefild-mobile">ค้นหาโดยข้อความ : </span>
            </v-flex>
          </v-layout>
          <v-layout>
            <!-- ช่องค้นหา -->
            <v-flex xs12 align-center py-3>
              <v-text-field color="#0f4898" solo light label="search" hide-details v-model="search" append-icon="search"
                style="width: 90%; margin-left: 20px; margin-right: 20px"></v-text-field>
            </v-flex>
          </v-layout>

          <v-flex md2 class="text-left">
            <v-btn outline fab color="#0f4898" dark small @click="dialog = true" style="margin-bottom: -40px;">
              <v-icon dark>mdi-cart-plus</v-icon>
            </v-btn>
          </v-flex>
        </v-container>


        <!-- Web View -->
        <v-container fluid grid-list-lg v-if="!mobileView">
          <v-layout justify-space-between align-center style="margin-top: 10px; margin-bottom: -40px;">
            <!-- ปุ่มร้านค้า -->
            <v-btn outline fab color="#0f4898" dark small @click="dialog = true">
              <v-icon dark>mdi-cart-plus</v-icon>
            </v-btn>

            <!-- ช่องค้นหา -->
            <v-layout justify-end align-center>
              <span class="texefild-mobile" style="margin-right: 8px;">ค้นหาโดยข้อความ :</span>
              <v-flex md3 style="margin-right: 10px;">
                <v-text-field color="#0f4898" solo light label="ค้นหาโดยข้อความ" hide-details v-model="search"
                  append-icon="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>




        <!-- table for desktop -->
        <div>
          <!-- <v-toolbar flat color="white"> -->
          <v-toolbar-title></v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <!-- add admin dialog -->
          <v-dialog v-model="dialog" max-width="500px">
            <!-- <template v-slot:activator="{ on }">
              <v-layout v-if="mobileView">
                <v-btn outline fab color="#0f4898" dark v-on="on" small>
                  <v-icon dark>mdi-store</v-icon>
                </v-btn>
              </v-layout>

              <v-layout v-if="!mobileView">
                <v-btn outline fab color="#0f4898" dark v-on="on" small>
                  <v-icon dark>mdi-store</v-icon>
                </v-btn>
              </v-layout>
            </template> -->
            <v-card>
              <v-card-title>
                <span class="addstore" style="color: #0f4898"><strong>Add Merchant</strong></span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 class="addstore">
                      <v-text-field ref="addid" prepend-icon="mdi-account" v-model="addID" label="ไอดีร้านค้า"
                        color="#0f4898" :rules="[() => !!addID || 'This field is required']" required
                        style="margin-top: -30px;"></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="addstore">
                      <v-text-field ref="addmerchant" prepend-icon="mdi-store" v-model="addMerchant" label="ชื่อร้านค้า"
                        color="#0f4898" :rules="[() => !!addMerchant || 'This field is required']" required
                        style="margin-top: -30px;"></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="addstore">
                      <v-text-field ref="addkey" prepend-icon="mdi-key" v-model="addKey" label="คีย์ร้านค้า"
                        color="#0f4898" :rules="[() => !!addKey || 'This field is required']" required
                        style="margin-top: -30px;"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false"
                  style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                  Cancel</v-btn>
                <v-btn @click="save"
                  style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                  Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- edit dialog -->
          <v-dialog v-model="dialog2" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline" style="color: #0f4898"><strong>Edit Merchant</strong></span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field ref="editmerchantid" prepend-icon="mdi-account" v-model="editMerchantID"
                        label="ไอดีร้านค้า" color="#0f4898"></v-text-field>
                      <v-text-field ref="editmerchant" prepend-icon="mdi-store" v-model="editMerchant"
                        label="ชื่อร้านค้า" color="#0f4898"></v-text-field>
                      <v-text-field ref="editkey" prepend-icon="mdi-key" v-model="editkey" label="คีย์ร้านค้า"
                        color="#0f4898"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog2 = false" style="
                    border-radius: 5px;
                    border: 1px solid #fc3a3a;
                    background-color: transparent;
                    color: #fc3a3a;
                  ">
                  Cancel</v-btn>
                <v-btn @click="edit" style="
                    border-radius: 5px;
                    border: 1px solid #51d245;
                    background-color: transparent;
                    color: #51d245;
                  ">
                  Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogConfirm" persistent max-width="500">
            <v-card>
              <v-card-title class="headline" style="color: #0f4898"><strong>Delete Admin</strong></v-card-title>
              <v-card-text>Are you sure you want to delete this admin?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialogConfirm = false" style="
                    border-radius: 5px;
                    border: 1px solid #000;
                    background-color: transparent;
                    color: #000;
                  ">
                  No</v-btn>
                <v-btn @click="deleteItem" style="
                    border-radius: 5px;
                    border: 1px solid #1976d2;
                    background-color: transparent;
                    color: #1976d2;
                  ">
                  OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-flex md12 pa-1 class="align-center" style="margin-right: 10px; margin-left: 10px;">
            <v-data-table :headers="headers" :items="merchantList" class="elevation-1" :search="search"
              disable-initial-sort id="mytable">
              <template v-slot:items="props">
                <td>{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.merchant_id }}</td>
                <td class="text-xs-left">{{ props.item.merchant_name }}</td>
                <td class="text-xs-left">{{ props.item.merchant_key }}</td>
                <td v-if="props.item.merchant_id == null" class="text-xs-left grey--text">
                  Not logged in yet
                </td>
                <td class="justify-center layout px-0">
                  <v-icon small color="#0f4898" class="mr-2"
                    @click="editItem(props.item.merchant_id, props.item.merchant_name, props.item.merchant_key, props.item.id)">
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="dialogDel(props.item.id,)">
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
            <!-- <p>{{editedItem}}</p> -->
          </v-flex>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from "moment";
import { sync } from "vuex-pathify";
moment.locale("en");
export default {
  data() {
    return {
      dialog: false,
      dialog2: false,
      dialogConfirm: false,
      account_id: this.$cookies.get("account_id"),
      currentId: {},
      search: '',
      addkey: '',
      addmerchant: '',
      addid: '',
      editMerchantID: '',
      editMerchant: '',
      editMail: '',
      // deleteItem: '',
      detID: null,
      merchantList: [],
      mydropdown: ["Admin"],
      newEmail: "", // เพิ่มตัวแปรนี้เพื่อเก็บค่าอีเมลใหม่
      headers: [
        { text: "No.", align: "left", sortable: false, value: "id" },
        { text: "ไอดีร้านค้า", align: "left", sortable: false, value: "merchant_id" },
        { text: "ชื่อร้านค้า", align: "left", value: "merchant_name" },
        { text: "คีย์ร้านค้า", align: "left", value: "merchant_key" },
        { text: "Action", align: "center", value: "action", sortable: false },
      ],
      editedItem: {
        email: "",
      },
      defaultItem: {
        email: "",
      },
    };
  },
  methods: {
    clearForm() {
      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset();
      });
    },
    async checkField() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formHasErrors = true;
        this.dialogloader = false;
        this.$refs[f].validate(true);
      });
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    async getmerchant() {
      try {
        this.istableloading = true;
        var { data } = await this.axios.get(
          `${process.env.VUE_APP_APIHOST}/merchants`,
          {
            headers: {
              Authorization: this.$cookies.get("token"),
            },
          }
        );
        this.merchantList = data.data
        // console.log(this.account_id)
        this.istableloading = false;
      } catch (error) {
        this.istableloading = false;
        console.log(error.message);
      }
    },
    editItem(merchant_id, merchant_name, merchant_key, id) {
      this.currentId = { merchant_id: merchant_id, merchant_name: merchant_name, merchant_key: merchant_key, id: id };
      this.editID = id;
      this.editMerchantID = merchant_id;
      this.editMerchant = merchant_name;
      this.editkey = merchant_key;
      this.dialog2 = true;
    },

    dialogDel(item) {
      this.detID = item
      this.dialogConfirm = true
      // console.log(this.delelteEmail)
    },
    async deleteItem() {
      this.istableloading = true
      let { data } = await this.axios.delete(`${process.env.VUE_APP_APIHOST}/merchants/${this.detID}`,
        {
          headers: { Authorization: this.$cookies.get('token') }
        })
      window.location.reload()
      //  && this.userList.splice(index, 1)
    },
    close() {
      this.clearForm();
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async save() {
      this.istableloading = true;

      if (!this.formHasErrors) {
        // ตรวจสอบว่าไม่มี error
        try {
          let { data } = await this.axios.post(
            `${process.env.VUE_APP_APIHOST}/merchants`,
            {
              merchantId: this.addID,
              merchantName: this.addMerchant,
              merchantKey: this.addKey
              // createdBy: this.$cookies.get("firstname"),
            },
            {
              headers: { Authorization: this.$cookies.get("token") },
            }
          );

          window.location.reload();
        } catch (error) {
          console.error(error);
          alert("An error occurred while saving."); // แจ้งเตือนข้อผิดพลาดจากการเชื่อมต่อ
        }
      }
    },

    async edit() {
      this.istableloading = true;
      let { data } = await this.axios.put(
        `${process.env.VUE_APP_APIHOST}/merchants/${this.editID}`,
        {
          merchantId: this.editMerchantID,
          merchantName: this.editMerchant,
          merchantKey: this.editkey
          // createBy: this.$cookies.get("firstname"),
        },
        {
          headers: { Authorization: this.$cookies.get("token") },
        }
      );
      // alert('Edit Success!')
      window.location.reload();
    },
  },
  created() {
    this.getmerchant();
    this.handleView();
    window.addEventListener("resize", this.handleView);
  },
  computed: {
    form() {
      return {
        addid: this.addID,
        addmerchant: this.addMerchant,
        addkey: this.addKey,
      };
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@300&display=swap");

html,
body {
  font-family: "Sarabun", sans-serif;
  font-size: 16.5px;
  /* font-weight: bold; */
}

#app {
  font-family: "Sarabun", sans-serif;
  font-size: 15px;
  /* font-weight: bold; */
}

.text {
  font-size: 16px;
}

.margin {
  margin-top: 0px;
}

.layout-btn {
  justify-content: center;
}

.text_b {
  text-align: center;
  margin-top: 15px;
}

.mt-text {
  margin-top: 5px;
}

/* .d_120px_clm {
  min-width: 0px;
}
.d_150px_clm {
  min-width: 150px;
} */
.v-text-field-title {
  border: #ccc;
  border-radius: 5px;
}

.text-b {
  /* text-align: left; */
  margin-top: 5px;
  margin-left: 20px;
  font-weight: bold;
  font-size: 18px;
}

.texefild-mobile {
  text-align: left;
  margin-top: 5px;
  font-weight: bold;
  font-size: 16px;
}

.texefild {
  text-align: left;
  margin-top: 15px;
  font-weight: bold;
  font-size: 16px;
}

.addstore {
  text-align: left;
  margin-top: 15px;
  margin-left: 20px;
  font-weight: bold;
  font-size: 20px;

}
</style>
